/* eslint-disable */

import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { erc20Abi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type ApproveWithdrawPairAllowanceProps = {
  account: Address
  chainId: number
  config: Config
  pairAddress: Address
  routerAddress: Address
  amount: bigint
}

export const approveWithdrawPairAllowance = async ({
  account,
  chainId,
  config,
  pairAddress,
  routerAddress,
  amount,
}: ApproveWithdrawPairAllowanceProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: erc20Abi as Abi,
        account,
        address: pairAddress,
        args: [routerAddress, amount],
        chainId,
        functionName: "approve",
      },
    })

    return result
  } catch (error: any) {
    console.error("approveWithdrawPairAllowance", error)
    return { success: false, error: error.message, code: error.code }
  }
}
